import { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(() =>
    localStorage.getItem("authToken"),
  );
  const [user, setUser] = useState(() =>
    authToken ? jwtDecode(authToken) : null,
  );

  // Items for automatic logout
  const MAX_IDLE_SEC = 30 * 60 * 1000; // Maximum idle time
  const CHECK_INTERVAL = 20 * 1000; // Update every 20 second
  const [idleCountDown, setIdleCountDown] = useState(MAX_IDLE_SEC);

  const login = (token) => {
    localStorage.setItem("authToken", token);
    setAuthToken(token);
    setUser(jwtDecode(token));
  };

  // eslint-disable-next-line
  const logout = () => {
    localStorage.removeItem("authToken");
    setAuthToken(null);
    setUser(null);
    window.location.href = "/login";
  };

  useEffect(() => {
    if (!authToken) return; // Early exist if token doesn't exist

    const tokenExpireTime = jwtDecode(authToken).exp;
    const currentTime = Math.floor(Date.now() / 1000);

    // Immediately logout if token is expired
    if (tokenExpireTime && tokenExpireTime <= currentTime) {
      logout();
      return;
    }

    // Update timer
    const logoutTimer = setInterval(() => {
      setIdleCountDown((i) => i - CHECK_INTERVAL);
      if (idleCountDown < 0) {
        logout();
      }
    }, CHECK_INTERVAL);

    const resetTimer = () => {
      setIdleCountDown(MAX_IDLE_SEC);
    };

    const activityEvents = ["mousemove", "keydown", "mousedown", "touchstart"];
    activityEvents.forEach((ev) => window.addEventListener(ev, resetTimer));

    return () => {
      clearTimeout(logoutTimer);
      activityEvents.forEach((ev) =>
        window.removeEventListener(ev, resetTimer),
      );
    };
    // eslint-disable-next-line
  }, [authToken, logout, MAX_IDLE_SEC]);

  return (
    <AuthContext.Provider
      value={{ authToken, user, login, logout, idleCountDown }}
    >
      {children}
    </AuthContext.Provider>
  );
};
